<template>
  <div class="Shortcuts">
    <div v-for="(item, index) in links" :key="index" class="shortcut-item" :style="{'background-image':'url('+item.icon+')'}" @click="go(item.url)" />
    <div class="shortcut-item add-btn"><i class="xi-plus xi-3x" color="#FFFFFF"></i></div>
  </div>
</template>

<script>
import daum from "@/assets/images/daum.png";
import tesla from "@/assets/images/tesla.png";
import naver from "@/assets/images/naver.png";
import googlemap from "@/assets/images/googlemap.png";
import youtube from "@/assets/images/youtube.png";
import disney from "@/assets/images/disney.png";
import google from "@/assets/images/google.png";
import kakaomap from "@/assets/images/kakaomap.png";
export default {
  name: "Shortcuts",
  data() {
    return {
      address: "",
      links:[
        { name:"다음", icon:daum, url:"https://www.daum.net/"},
        { name:"네이버", icon:naver, url:"https://www.naver.net/"},
        { name:"테슬라", icon:tesla, url:"https://www.tesla.com/"},
        { name:"유튜브", icon:youtube, url:"https://www.youtube.com/"},
        { name:"구글맵", icon:googlemap, url:"https://www.google.co.kr/maps"},
        { name:"디즈니플러스", icon:disney, url:"https://www.disneyplus.com"},
        { name:"구글", icon:google, url:"https://www.google.com"},
        { name:"카카오맵", icon:kakaomap, url:"https://map.kakao.com/"},
        
      ]
    };
  },
  mounted() {},
  methods: {
    itemTitle(item) {
      let result = item.i;
      if (item.static) {
          result += " - Static";
      }
      return result;
    },
    go(url) {
      location.href = "https://www.youtube.com/redirect?q=" + url;
    }
  }
};
</script>

<style scoped>
.Shortcuts {
  position: relative;
  width:100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap:40px;
  align-items: center;
  padding:20px;
  box-sizing: border-box;
  padding-top:50px;
}
.shortcut-item{
  position:relative;
  display: inline-block;
  width:240px; 
  height:150px; 
  min-width:240px;
  min-height:150px;
  box-sizing: border-box;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 70%;
  text-align:center;
  background-color:rgba(255,255,255,0.075);
  border-radius: 10px;
  overflow: hidden;
  transition: all 0.15s;
}
.shortcut-item:active{
  background-color:#EEEEEE;
  background-size: 65%;
  transition: all 0.15s;
  transform: scale(1.2);
  filter:drop-shadow(0px 0px 30px rgba(255,255,255,1));

  animation-name:vibrationAni;
  animation-duration: 0.05s;
  animation-iteration-count: infinite;
  animation-direction: alternate-reverse;
  animation-timing-function: linear;
}
.add-btn{
  color:#666666;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color:rgba(255,255,255,0.15);
}
.add-btn:active{
  color:#000000;
  display: flex;
  align-items: center;
  justify-content: center;
}
@keyframes vibrationAni {
  from{
    transform: rotate(-2deg) scale(1.1);
  }
  to{
    transform: rotate(2deg) scale(1.1);
  }
}

div.des {
  color: #666666;
  transform: rotate(-0.03deg);
  margin-top: 30px;
  letter-spacing: -0.5px;
}

div.Economy input {
  height: 50px;
  width: 800px;
  border: 1px solid #333333;
  margin-bottom: 40px;
  font-size: 20px;
  text-align: center;
  letter-spacing: -0.5px;
  transform: rotate(-0.028deg);
  border-radius: 5px;
  background-color: #ff3333;
  color: #ffffff;
  outline: none;
  font-weight: 200;
}

div.Economy input::placeholder {
  color: rgba(255, 255, 255, 0.6);
  font-weight: 200;
}
</style>



// WEBPACK FOOTER //
// src/pages/Shortcuts/index.vue